// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"222":"62ee1dc8","310":"318c94f3","966":"b46cb2d5"}[chunkId] + ".css";
};